// src/constants/accommodationTypes.js
// New file: Centralizes accommodation types and helper for combining with tenants.

export const accommodationTypes = [
  { value: 'single', ar: 'غرفة سينجل', en: 'Single room' },
  { value: 'double', ar: 'غرفة دوبل', en: 'Double room' },
  { value: 'triple', ar: 'غرفة تريبل', en: 'Triple room' },
];

export const getAccommodationTypeWithTenants = (typeValue, tenantsPolicy, language) => {
  const typeObj = accommodationTypes.find(t => t.value === typeValue);
  const baseType = language === 'ar' ? (typeObj?.ar || typeValue) : (typeObj?.en || typeValue);

  const tenantsAr = { males: 'للذكور', females: 'للإناث' };
  const tenantsEn = { males: 'for Males', females: 'for Females' };
  const tenantsSuffix = language === 'ar' 
    ? (tenantsAr[tenantsPolicy] || '') 
    : (tenantsEn[tenantsPolicy] || '');

  return tenantsSuffix ? `${baseType} ${tenantsSuffix}` : baseType;
};